<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { getConfig, klinikenApi } from "@/api";
    import { flashWarning } from "@/utils";

    withDefaults(defineProps<{ label?: string }>(), { label: "Idrott" });

    // IdrotterView returnerar en platt array av idrottsnamn (strängar), inte objekt.
    const fetchIdrott = async ({ query }: { query?: string } = {}) => {
        try {
            const response = await klinikenApi.get("skreg/statistik/idrotter/", getConfig());
            const items: string[] = query
                ? response.data.filter((namn: string) => namn.toLowerCase().includes(query.toLowerCase()))
                : response.data;

            return items.map((namn) => ({ value: namn, label: namn }));
        } catch {
            flashWarning("Kunde inte hämta idrotter");
        }
    };
</script>

<template>
    <KAutocomplete
        name="idrott"
        :label="label"
        v-bind="$attrs"
        v-on="$listeners"
        :options="fetchIdrott"
        :onSearch="fetchIdrott"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
